import DeveloperLayout from '@/layouts/DeveloperLayout.vue'

export const API_KEY_ROUTES = [
  {
    path: 'api-keys/create',
    name: 'CreateApiKey',
    component: () => import('./views/CreateApiKey.vue'),
  },
  {
    path: 'api-keys/:id/edit',
    name: 'EditApiKey',
    component: () => import('./views/EditApiKey.vue'),
  },
  {
    path: 'api-keys',
    component: DeveloperLayout,
    redirect: { name: 'ApiKeys' },
    children: [
      {
        path: 'api-keys',
        name: 'ApiKeys',
        component: () => import('./views/ApiKeyList.vue'),
      },
      {
        path: 'api-logs',
        name: 'ApiLogs',
        component: () => import('./views/ApiLogs.vue'),
      },
    ],
  },
]
